import { ServiceContent } from '@/base-api/types';
import { InfoModalInner } from '@/components/info-modal-inner';
import { useDialog } from '@/contexts/dialog-context';

type InfoModalContent = ServiceContent['info_modal'];

export const useInfoModal = (content: InfoModalContent) => {
  const { setOpen, setContent } = useDialog();

  const openInfoModal = () => {
    setContent(<InfoModalInner content={content} />);
    setOpen(true);
  };

  return openInfoModal;
};
